import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  createGroupChargeService,
  getEmployersService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import { formatToEnglishDate } from "../../../utils";

export const groupChargeAdminContext = createContext({
  employers: [],
  setEmployers: () => {},
  balance: "",
  setBalance: () => {},
  employer: "",
  setEmployer: () => {},
  smsType: "",
  setSmsType: () => {},
  from: {},
  setFrom: () => {},
  to: {},
  setTo: () => {},
  smsText: "",
  setSmsText: () => {},
  handleGetEmployerList: () => {},
  handleCreateGroupCharge: () => {},
});

const GroupChargeAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [employers, setEmployers] = useState([]);
  const [balance, setBalance] = useState("");
  const [employer, setEmployer] = useState("");
  const [smsType, setSmsType] = useState("organization");
  const [from, setFrom] = useState({});
  const [to, setTo] = useState({});
  const [smsText, setSmsText] = useState("");

  const handleResetState = () => {
    setBalance("");
    setEmployer("");
    setSmsType("organization");
    setFrom({});
    setTo({});
    setSmsText("");
  };

  // Handle Get Employer List Method
  const handleGetEmployerList = async (event) => {
    event?.preventDefault();

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getEmployersService();
      if (status === 200) {
        setEmployers(data.list);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create Group Charge Method
  const handleCreateGroupCharge = async (event, change_type) => {
    event?.preventDefault();

    if (!balance) return toastErrorMessage("مبلغ الزامی است");

    const objData = {
      current_balance: +balance,
      ...(smsType === "organization" && employer && { employer: +employer }),
      sms_type: smsType,
      ...(from && {
        from_date: new Date(from).toISOString().split("T")[0].concat(" 00:00:00"),
      }),
      to_date: new Date(to).toISOString().split("T")[0].concat(" 23:59:59"),
      ...(smsText && { sms_text: smsText }),
      change_type,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createGroupChargeService(objData);
      if (status === 200) {
        toastSuccessMessage("شارژ گروهی با موفقیت انجام شد");
        handleResetState();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <groupChargeAdminContext.Provider
      value={{
        employers,
        setEmployers,
        balance,
        setBalance,
        employer,
        setEmployer,
        smsType,
        setSmsType,
        from,
        setFrom,
        to,
        setTo,
        smsText,
        setSmsText,
        handleGetEmployerList,
        handleCreateGroupCharge,
      }}
    >
      {children}
    </groupChargeAdminContext.Provider>
  );
};

export default GroupChargeAdminContext;
